import { CSSObject } from "@emotion/react";

import { overviewFontBuilderCss } from "@/reports/teacher/common/OverviewDataResults/OverviewDataResults.style";

export const containerCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
};

export const headerTextCss = (shrinkHeader?: boolean): CSSObject => ({
  minWidth: !shrinkHeader ? "105px" : "60px",
  fontWeight: "700",
  fontSize: "16px",
});

export const headerInfoCss: CSSObject = {
  margin: "0",

  ...overviewFontBuilderCss({
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "150%",
  }),
};
